var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.293 10.7068L11.293 3.70685C11.6835 3.31647 12.3165 3.31647 12.707 3.70685L19.707 10.7068C19.8945 10.8943 20 11.1487 20 11.4138V20.9998C20 21.5521 19.5523 21.9998 19 21.9998H14V14.9998H10V21.9998H5C4.44772 21.9998 4 21.5521 4 20.9998V11.4138C4 11.1487 4.10545 10.8943 4.293 10.7068Z",
    fill: "#475A66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home_active.4d3e6221536f9b0e24abcf7cbf9e809e.svg";
export { ForwardRef as ReactComponent };